export default __webpack_public_path__ + "static/media/_A6A9858.360d0857.jpg";